import { createContext, useContext } from "react"

// Null default forces consumers to be inside a DashboardIdProvider — useDashboardId throws otherwise.
const DashboardIdContext = createContext<string | null>(null)

export const DashboardIdProvider = DashboardIdContext.Provider

export function useDashboardId(): string {
  const id = useContext(DashboardIdContext)
  if (id === null) {
    throw new Error(
      "useDashboardId must be called inside a DashboardIdProvider. "
        + "Wrap your component tree with <DashboardIdProvider value=\"default\">.",
    )
  }
  return id
}
